



// Vue
import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {Mixins} from 'vue-mixin-decorator';

// Components
import TopModal from '@/shared/components/TopModal.component.vue';
import FieldSet from '@/shared/components/field-set.component.vue';
import Spinner from '@/shared/components/Spinner.component.vue';

// Filters
import formatDate from '@/shared/filters/formatDate.filter';

// Services
import UtilsService from '@/core/services/utils.service';
import ErrorMixin from "@/shared/mixins/error.mixin";
import $http from '@/core/services/http.service';
import Endpoints from "@/constants/endpoints";


interface MixinInterface extends ErrorMixin {
}

@Component({
  components: {
    FieldSet,
    TopModal,
    Spinner,
  },
  computed: {}, filters: {
    formatDate,
  },
})
export default class ParticipantClientCsvModal extends Mixins<MixinInterface>(ErrorMixin) {
  @Prop({default: true}) private opened!: boolean;
  private utilsService = UtilsService;
  private rowCsv = [];
  private extraInfo = {}
  private loading = false;


  private closeModal() {
    if (this.opened) {
      this.$emit('close-modal');
    }
  }

  private mounted() {
    if (this.opened) {
      this.getLog();
    }
  }

  private getName(info: any): string {
    const {client} = info || info.participant
    return client ? client.user.fullName : '-'
  }

  private getEmail(info: any): string {
    const {client} = info || info.participant
    return client ? client.user.email : '-'
  }

  getUrl() {
    const participant = this.$route.query['participant-uploaded-details']
    const client = this.$route.query['client-uploaded-details']
    const endpoint = participant ? Endpoints.participantCsvDetail : Endpoints.clientCsvDetail
    return endpoint(participant || client)
  }

  private getLog() {
    this.loading = true
    $http.get(`${this.getUrl()}`)
        .then(({data}) => {
          const {rowCsv, ...extraInfo} = data
          this.rowCsv = rowCsv;
          this.extraInfo = extraInfo;
          this.loading = false;
        }).catch((err) => {
      this.$router.push(this.$route.path)
      this.loading = false;
      setTimeout(() => {
        this.$emit('error-loading-log', 'Hemos presentado problemas al cargar el reporte de importación');
      })
    });

  }


}
